import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "goods"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "goods-title"
};
const _hoisted_4 = {
  class: "goods-price"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "van-cell-text"
}, "有赞的店", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_action_bar_icon = _resolveComponent("van-action-bar-icon");
  const _component_van_action_bar_button = _resolveComponent("van-action-bar-button");
  const _component_van_action_bar = _resolveComponent("van-action-bar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_swipe, {
    class: "goods-swipe",
    autoplay: 3000
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.goods.thumb, thumb => {
      return _openBlock(), _createBlock(_component_van_swipe_item, {
        key: thumb
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: thumb
        }, null, 8, _hoisted_2)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }), _createVNode(_component_van_cell_group, null, {
    default: _withCtx(() => [_createVNode(_component_van_cell, null, {
      title: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString($data.goods.title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString($options.formatPrice($data.goods.price)), 1)]),
      _: 1
    }), _createVNode(_component_van_cell, {
      class: "goods-express"
    }, {
      title: _withCtx(() => [_createVNode(_component_van_col, {
        span: "10"
      }, {
        default: _withCtx(() => [_createTextVNode("运费：" + _toDisplayString($data.goods.express), 1)]),
        _: 1
      }), _createVNode(_component_van_col, {
        span: "14"
      }, {
        default: _withCtx(() => [_createTextVNode("剩余：" + _toDisplayString($data.goods.remain), 1)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    class: "goods-cell-group"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      value: "进入店铺",
      icon: "shop-o",
      "is-link": "",
      onClick: $options.sorry
    }, {
      title: _withCtx(() => [_hoisted_5, _createVNode(_component_van_tag, {
        class: "goods-tag",
        type: "danger"
      }, {
        default: _withCtx(() => [_createTextVNode("官方")]),
        _: 1
      })]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_cell, {
      title: "线下门店",
      icon: "location-o",
      "is-link": "",
      onClick: $options.sorry
    }, null, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_van_cell_group, {
    class: "goods-cell-group"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell, {
      title: "查看商品详情",
      "is-link": "",
      onClick: $options.sorry
    }, null, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_van_action_bar, null, {
    default: _withCtx(() => [_createVNode(_component_van_action_bar_icon, {
      icon: "chat-o",
      onClick: $options.sorry
    }, {
      default: _withCtx(() => [_createTextVNode(" 客服 ")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_action_bar_icon, {
      icon: "cart-o",
      onClick: $options.onClickCart
    }, {
      default: _withCtx(() => [_createTextVNode(" 购物车 ")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_action_bar_button, {
      type: "warning",
      onClick: $options.sorry
    }, {
      default: _withCtx(() => [_createTextVNode(" 加入购物车 ")]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_van_action_bar_button, {
      type: "danger",
      onClick: $options.sorry
    }, {
      default: _withCtx(() => [_createTextVNode(" 立即购买 ")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })]);
}